import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { PromoteContainer } from '../PromoteContainer';
import { usePostsFilters } from './hooks/usePostsFilters';
import { postsMessages } from './postsMessages';
import { PostsBoard } from './PostsBoard';
import { PostsHeadActions } from './PostsHeadActions';
import { PostsTabRow } from './PostsTabRow';

/**
 * The Posts page route (`/app/promote/promotePosts`, design assets-rethink c1, c2): the Board tab
 * of Posts (design navigation-v2 c 3b). The head holds the scheduled-post quota (d3), "Make in
 * Studio" and "New post" (the Composer, a page under Posts), then the tabs Board · Calendar and
 * the board. `?view=archive` shows the archive, a page under Posts with no tabs.
 */
const PostsViewComponent: React.FC = () => {
  const intl = useIntl();
  const accountId = useAccountId();
  const { view } = usePostsFilters();
  if (accountId === null) {
    return <LoadingView />;
  }
  const title = intl.formatMessage(postsMessages.title);
  const isArchive = view === 'archive';
  return (
    <PromoteContainer
      title={isArchive ? intl.formatMessage(postsMessages.archiveTitle) : title}
      subtitle={isArchive ? undefined : intl.formatMessage(postsMessages.subtitle)}
      crumbs={isArchive ? [title, intl.formatMessage(postsMessages.archiveTitle)] : [title]}
      actions={isArchive ? undefined : <PostsHeadActions accountId={accountId} />}
      tabs={isArchive ? undefined : <PostsTabRow accountId={accountId} screen={SMLRouteNames.promotePosts} />}
    >
      <PostsBoard key={accountId} accountId={accountId} />
    </PromoteContainer>
  );
};

export const PostsView = TypedMemo(PostsViewComponent);
